import { render } from "./Enterprise_page_en.vue?vue&type=template&id=1dae0312&scoped=true"
import script from "./Enterprise_page_en.vue?vue&type=script&lang=js"
export * from "./Enterprise_page_en.vue?vue&type=script&lang=js"

import "./Enterprise_page_en.vue?vue&type=style&index=0&id=1dae0312&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dae0312"

export default script